export default "__VITE_ASSET__DmbJXRVS__"